import { __extends, __assign } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import Beacon from '../Beacon/Beacon.js';
import Divider from '../Divider/Divider.js';
import styles from './Popover.module.scss.js';

var Popover = (function (_super) {
    __extends(Popover, _super);
    function Popover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.spacer = 10;
        _this.state = {
            size: undefined,
            isOpaque: false,
        };
        _this.setPopoverRef = function (r) {
            _this.popover = r;
            _this.updateSize();
        };
        _this.updateSize = function () {
            if (_this.popover) {
                var rect_1 = _this.popover.getBoundingClientRect();
                if (!_this.state.size || _this.state.size.width !== rect_1.width || _this.state.size.height !== rect_1.height) {
                    _this.setState({
                        size: rect_1,
                    }, function () {
                        setTimeout(function () {
                            var _a, _b;
                            if (((_a = _this.state.size) === null || _a === void 0 ? void 0 : _a.width) === rect_1.width &&
                                ((_b = _this.state.size) === null || _b === void 0 ? void 0 : _b.height) === rect_1.height &&
                                !_this.state.isOpaque) {
                                _this.setState({
                                    isOpaque: true,
                                });
                            }
                        }, 80);
                    });
                }
            }
        };
        _this.getPopoverStyle = function () {
            if (!_this.state.size) {
                return undefined;
            }
            switch (_this.props.position) {
                case 'top': {
                    return {
                        top: "-" + (_this.state.size.height + _this.spacer) + "px",
                        left: '50%',
                        marginLeft: "-" + _this.state.size.width / 2 + "px",
                    };
                }
                case 'right': {
                    return {
                        top: '50%',
                        right: "-" + (_this.state.size.width + _this.spacer) + "px",
                        marginTop: "-" + _this.state.size.height / 2 + "px",
                    };
                }
                case 'bottom': {
                    return {
                        bottom: "-" + (_this.state.size.height + _this.spacer) + "px",
                        left: '50%',
                        marginLeft: "-" + _this.state.size.width / 2 + "px",
                    };
                }
                case 'left': {
                    return {
                        top: '50%',
                        left: "-" + (_this.state.size.width + _this.spacer) + "px",
                        marginTop: "-" + _this.state.size.height / 2 + "px",
                    };
                }
                default: {
                    return undefined;
                }
            }
        };
        _this.getBeaconPosition = function () {
            var s = _this.spacer + 25;
            var styles = {
                left: { right: "-" + s + "px", top: '50%', transform: 'translateY(-50%)' },
                right: { left: "-" + s + "px", top: '50%', transform: 'translateY(-50%)' },
                top: { left: '50%', bottom: "-" + s + "px", transform: 'translateX(-50%)' },
                bottom: { left: '50%', top: "-" + s + "px", transform: 'translateX(-50%)' },
            };
            return __assign({ position: 'absolute' }, styles[_this.props.position]);
        };
        _this.getBackground = function () {
            var o = parseInt(styles.o) || 10;
            var w = _this.state.size ? _this.state.size.width : 0;
            var h = _this.state.size ? _this.state.size.height : 0;
            var wc = w / 2;
            var hc = h / 2;
            var sw = 1;
            var swh = sw / 2;
            var points = '';
            switch (_this.props.position) {
                case 'top': {
                    points = swh + "," + swh + " " + (w - swh) + "," + swh + " " + (w - swh) + "," + (h - o - swh) + " " + (wc + o) + "," + (h - o - swh) + " " + wc + "," + (h - swh) + " " + (wc - o) + "," + (h - o - swh) + " " + swh + "," + (h - o - swh);
                    break;
                }
                case 'right': {
                    points = swh + o + "," + swh + " " + (w - swh) + "," + swh + " " + (w - swh) + "," + (h - swh) + " " + (swh + o) + "," + (h - swh) + " " + (swh + o) + "," + (hc + o) + " " + swh + "," + hc + " " + (swh + o) + "," + (hc - o);
                    break;
                }
                case 'bottom': {
                    points = swh + "," + (swh + o) + " " + (wc - o) + "," + (swh + o) + " " + wc + "," + swh + " " + (wc + o) + "," + (swh + o) + " " + (w - swh) + "," + (swh + o) + " " + (w - swh) + "," + (h - swh) + " " + swh + "," + (h - swh);
                    break;
                }
                case 'left': {
                    points = swh + "," + swh + " " + (w - swh - o) + "," + swh + " " + (w - swh - o) + "," + (hc - o) + " " + (w - swh) + "," + hc + " " + (w - swh - o) + "," + (hc + o) + "  " + (w - swh - o) + "," + (h - swh) + " " + swh + "," + (h - swh);
                    break;
                }
            }
            return (React.createElement("div", { className: styles.background },
                React.createElement("svg", { width: '100%', height: '100%', viewBox: "0 0 " + w + " " + h },
                    React.createElement("polygon", { className: styles.polygon, fill: "none", stroke: 'rgba(255,204,102,0.7)', strokeWidth: sw, points: points }))));
        };
        return _this;
    }
    Popover.prototype.componentDidMount = function () {
        this.interval = setInterval(this.updateSize, 50);
    };
    Popover.prototype.componentWillUnmount = function () {
        clearInterval(this.interval);
    };
    Popover.prototype.render = function () {
        var _a;
        var wrapper = classNames(styles.wrapper, this.props.className, styles["position-" + this.props.position]);
        var popover = classNames(styles.popover, (_a = {},
            _a[styles.invisible] = !this.state.isOpaque,
            _a));
        return (React.createElement("div", { className: wrapper, onClick: this.props.onClick },
            this.props.children,
            this.props.isVisible ? (React.createElement("div", { className: popover, style: this.getPopoverStyle(), ref: this.setPopoverRef },
                !!this.props.withBeacon && React.createElement(Beacon, { style: this.getBeaconPosition(), className: styles.beacon }),
                React.createElement("div", { className: classNames(styles.inner, this.props.blockClassName || null) },
                    this.getBackground(),
                    this.props.header ? (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: styles.header },
                            this.props.header,
                            React.createElement("div", { className: styles.close, onClick: this.props.onClose })),
                        React.createElement(Divider, { type: 'major_light' }))) : null,
                    this.props.content ? React.createElement("div", { className: styles.content }, this.props.content) : null))) : null));
    };
    return Popover;
}(React.PureComponent));

export { Popover as default };
//# sourceMappingURL=Popover.js.map
